import React from "react";
import LocaleTextarea from "./LocaleTextarea";
import Input from "./Input";
import Switch from "./Switch";
import { getFillerPromptText, getLanguageLabel } from "../utilities";
import { defaultTtsVoice, LanguageCode } from "../types";

export default class FillerPromptsSectionGroup extends React.Component {
    constructor(props){
        super(props);
        const counter = this.props.prompts.filter(p => p.externalAudioPrompt).length;
        this.state = {
            fillertoggled: counter > 0,
            togglecounter: counter
        };
        this.fillertoggle = this.fillertoggle.bind(this);
    }

    fillertoggle(newVal) {
        this.setState({fillertoggled: newVal, togglecounter: counter});
        let counter = this.state.togglecounter;
        if(newVal) {
            counter++;
        } else if(!newVal) {
            counter--;
        }
        if(counter > 0) {
            newVal = true;
        } else {
            newVal = false;
        }
        this.setState({fillertoggled: newVal, togglecounter: counter});
    }

    render () {
        const getHeader = () => {
            return(
                <div className="panel-heading" role="tab" style={{padding:"0",paddingLeft:"15px"}}>
                    <div className={"row"}>
                        <div className={"col-md-12"} style={{padding:"10px"}}>
                            <div className="panel-title">
                                <i className={"fe icon-message-square"}/>&nbsp;&nbsp;{this.props.title}
                            </div>
                        </div>
                    </div>
                </div>
            );
        }

        const formatLabel = (key) => {
            return key.replace(/_/ig, ' ');
        };

        const getRows = (prompts) => {
            const rowJsx = prompts.map((prompt, idx) => {
                const key = prompt.name;
                const languageCode = this.props.language;

                const englishTtsVoice = this.props.ttsVoices?.[LanguageCode.englishUs] ?? defaultTtsVoice;
                const ttsVoice = this.props.ttsVoices?.[languageCode] ?? defaultTtsVoice;

                const englishText = getFillerPromptText({ languageCode: LanguageCode.englishUs, prompt, ttsVoice: englishTtsVoice });
                const nonEnglishText = getFillerPromptText({ languageCode, prompt, ttsVoice });
                const addRows = (this.props.language !== LanguageCode.englishUs) ? 1 : 0;
                return (
                    <tr key={key}>
                        <th scope="row">
                            <label>
                                {formatLabel(key)}
                            </label>
                        </th>
                        <td>
                            <LocaleTextarea
                                rowsVal={this.props.rows + addRows}
                                defaultValue={englishText}
                                valKey="prompt"
                                idx={idx}
                                context={this.props.context}
                                ttsVoice={ttsVoice}
                                type={this.props.type}
                                language={this.props.language}
                                isEnUS={true}
                            />
                        </td>
                        {addRows > 0 &&
                            <td>
                                <LocaleTextarea
                                    rowsVal={this.props.rows + addRows}
                                    defaultValue={nonEnglishText}
                                    valKey="prompt"
                                    idx={idx}
                                    context={this.props.context}
                                    type={this.props.type}
                                    language={this.props.language}
                                    isEnUS={false}
                                />
                            </td>
                        }
                        <td>
                            <Switch
                                fillertoggle={this.fillertoggle}
                                context={this.props.context}
                                key='externalAudioPrompt'
                                language={this.props.language}
                                type={this.props.type}
                                idx={idx}
                                valKey='externalAudioPrompt'
                                checked={prompt.externalAudioPrompt}
                            />
                        </td>
                        {this.state.fillertoggled && (
                            <td>
                                {prompt.externalAudioPrompt && (
                                <Input
                                    context={this.props.context}
                                    valKey={'externalAudioServiceUrl'}
                                    language={this.props.language}
                                    type={this.props.type}
                                    idx={idx}
                                    value={prompt.externalAudioServiceUrl}
                                />
                                )}
                            </td>
                        )}
                    </tr>
                );
            });

            return rowJsx;
        };

        const getPromptsTable = () => {
            const addCol = this.props.language !== LanguageCode.englishUs;

            let english = window.apm.knowledgeBase.getItemFromValue(LanguageCode.englishUs, window.apm.serialized.languages, "language");
            const ttsFallBackVoice = this.props.ttsVoices?.[LanguageCode.englishUs] ?? defaultTtsVoice;
            english = { ...english, ttsFallBackVoice };

            let nonEnglish;

            if (addCol) {
                const ttsFallBackVoice = this.props.ttsVoices?.[this.props.language] ?? defaultTtsVoice;
                nonEnglish = window.apm.knowledgeBase.getItemFromValue(this.props.language, window.apm.serialized.languages, "language");
                nonEnglish = { ...nonEnglish, ttsFallBackVoice };
            }
            
            return(
                <div className="panel-collapse collapse in" role="tabpanel">
                    <div className="panel-body">
                        <div className="row">
                            <table className="table table-condensed table-settings">
                                <thead>
                                    <tr>
                                        <td className="narrow">{window.l.settings.prompt_node_name}</td>
                                        <td>
                                            {
                                                getLanguageLabel({
                                                    designLanguage: english,
                                                    includeTts: english.ttsFallBackVoice !== defaultTtsVoice,
                                                    includeVt: false
                                                })
                                            }
                                        </td>
                                        {addCol && (
                                            <td>
                                            {
                                                getLanguageLabel({
                                                    designLanguage: nonEnglish,
                                                    includeTts: nonEnglish.ttsFallBackVoice !== defaultTtsVoice,
                                                    includeVt: false
                                                })
                                            }
                                            </td>
                                        )}
                                        <td className="narrow">External Audio Prompt</td>
                                        {this.state.fillertoggled && <td className="narrow">External Audio Service Url</td>}
                                    </tr>
                                </thead>
                                <tbody>
                                    { getRows(this.props.prompts) }
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            );
        }

        return (
            <div className="panel-group" role="tablist">
                <div className="panel panel-default">
                    {getHeader()}
                    {getPromptsTable()}
                </div>
            </div>
        )
    }
}
